<div class="mt-3">
	<seira-highchart
		classChart="highcharts-light h-auto"
		styleChart="width: 100%; height: 600px; display: block"
		(chartInstance)="onChartCreated($event)"
		[options]="chartOptions" />
</div>
